import {NotionalRegisterNpa} from '../../modules'

export const RegisterNpaPage = () => {
  return <NotionalRegisterNpa />
}
